import React from 'react';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';

export class BreadCrumb extends React.Component {
    render() {
        return (
            <div className="m-subheader m-container m-container--responsive m-container--xxl" style={{paddingTop: "0px", paddingBottom: "20px"}}>
                <div className="d-flex align-items-center">
                    <div className="mr-auto">
                        <ul className="m-subheader__breadcrumbs m-nav m-nav--inline">
                            <li className="m-nav__item m-nav__item--home">
                                <NavLink to={`/`} className="m-nav__link m-nav__link--icon">
                                    <i className="m-nav__link-icon la la-home"></i>
                                </NavLink>
                            </li>
                            {this.props.items.map((i, key) => (
                                <React.Fragment key={key}>
                                    <li className="m-nav__separator">-</li>
                                    <li className="m-nav__item">
                                        <NavLink to={i.to} className="m-nav__link">
                                            <span className="m-nav__link-text">{i.title}</span>
                                        </NavLink>
                                    </li>
                                </React.Fragment>
                            ))
                            }
                        </ul>
                    </div>
                    
                </div>
            </div>
        )
    }
}

